import { apiClient, type Paginated } from '@/core/api';
import type { ReviewStatus } from './constants';
import type {
  PerformanceReview,
  PerformanceReviewInput,
  ReviewActionItem,
  ReviewActionItemInput,
} from './types';

export const BASE = '/hrm/performance-reviews/';
const ACTION_ITEMS = '/hrm/review-action-items/';

export interface ReviewListParams {
  page?: number;
  employee?: number;
  status?: ReviewStatus;
  reviewer?: number;
  /** Free-text search — matches employee name + period. */
  search?: string;
  /** DRF `OrderingFilter` value, e.g. `period` or `-review_date`. */
  ordering?: string;
}

export async function listReviews(params: ReviewListParams = {}): Promise<Paginated<PerformanceReview>> {
  const { data } = await apiClient.get<Paginated<PerformanceReview>>(BASE, { params });
  return data;
}

export async function getReview(id: string | number): Promise<PerformanceReview> {
  const { data } = await apiClient.get<PerformanceReview>(`${BASE}${id}/`);
  return data;
}

export async function createReview(input: PerformanceReviewInput): Promise<PerformanceReview> {
  const { data } = await apiClient.post<PerformanceReview>(BASE, input);
  return data;
}

export async function updateReview(
  id: string | number,
  input: Partial<PerformanceReviewInput>,
): Promise<PerformanceReview> {
  const { data } = await apiClient.patch<PerformanceReview>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteReview(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

// ---- Action items (detail-page checklist) ----------------------------------

export async function createReviewActionItem(
  input: ReviewActionItemInput,
): Promise<ReviewActionItem> {
  const { data } = await apiClient.post<ReviewActionItem>(ACTION_ITEMS, input);
  return data;
}

export async function updateReviewActionItem(
  id: number,
  input: Partial<ReviewActionItemInput>,
): Promise<ReviewActionItem> {
  const { data } = await apiClient.patch<ReviewActionItem>(`${ACTION_ITEMS}${id}/`, input);
  return data;
}

export async function deleteReviewActionItem(id: number): Promise<void> {
  await apiClient.delete(`${ACTION_ITEMS}${id}/`);
}
